export default __webpack_public_path__ + "static/media/query-message-golden.5c7d5b22.svg";